import { launchUrl, type Instance } from '../api';
import { relativeTime } from '../format';
import { StatusBadge } from './StatusBadge';

export function instanceUrl(i: Instance): string | null {
  if (i.url) return i.url;
  if (i.kind === 'local' && i.localPort) return `http://127.0.0.1:${i.localPort}/`;
  return null;
}

export function InstanceCard({ instance }: { instance: Instance }) {
  const label = instance.kind === 'cloud' ? 'Cloud' : 'Local';
  const ready = instance.status === 'ready';
  const url = instanceUrl(instance);
  return (
    <article className="card" aria-label={`Instance ${label}`} data-kind={instance.kind}>
      <header className="card-head">
        <h3>
          <span aria-hidden="true">{instance.kind === 'cloud' ? '☁️ ' : '💻 '}</span>
          {label}
        </h3>
        <StatusBadge status={instance.status} />
      </header>
      <dl className="meta">
        <div>
          <dt>Canal</dt>
          <dd>{instance.channel === 'stable' ? 'Stable' : 'Canary'}</dd>
        </div>
        <div>
          <dt>Version</dt>
          <dd>{instance.version ?? '—'}</dd>
        </div>
        <div>
          <dt>Dernière activité</dt>
          <dd>{relativeTime(instance.lastSeenAt)}</dd>
        </div>
        <div>
          <dt>Adresse</dt>
          <dd className="url">{url ?? '—'}</dd>
        </div>
      </dl>
      {instance.status === 'failed' && (
        <p className="hint">Le déploiement a échoué : contactez un administrateur.</p>
      )}
      <div className="card-actions">
        {ready ? (
          <a className="btn btn-primary" href={launchUrl(instance.kind)}>
            Ouvrir<span className="sr-only"> l'instance {label}</span>
          </a>
        ) : (
          <button type="button" className="btn btn-primary" disabled>
            Ouvrir<span className="sr-only"> l'instance {label}</span>
          </button>
        )}
      </div>
    </article>
  );
}
